/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResourceAction, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';
import {ApiConfig} from '../../api';

/** Angular DI token for the PoliticalSponsor HTTP resource (factory product). */
export class PoliticalSponsorResource {
}

export function createPoliticalSponsorResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const uri = ApiConfig.obtain().getVersionedUri('politicalsponsors');

  return {
    summary: createAdnHttpResourceAction(send, {
      method: 'GET',
      url: uri,
      queryParams: ['network', 'groupBy', 'page', 'pageSize'],
      hasBody: false
    })
  };
}

export const politicalSponsorResourceProvider = {
  provide: PoliticalSponsorResource,
  useFactory: createPoliticalSponsorResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService]
};
